export default __webpack_public_path__ + "static/media/HDTX_Announcement_of_GMS_2021.3bac1abb.pdf";